// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default[data-v-45f35f38]{--lines:3;display:-webkit-box;max-width:100%;-webkit-line-clamp:var(--lines);-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.default[data-v-45f35f38],.expanded[data-v-45f35f38]{white-space:pre-line}.expanded[data-v-45f35f38]{display:block;display:-webkit-box}.anchor[data-v-45f35f38]{display:block;text-align:right;padding:8px;margin-bottom:4px;color:#1976d2;cursor:pointer}.container[data-v-45f35f38]{padding:10px}", ""]);
// Exports
module.exports = exports;
